import { useState, useEffect, useCallback } from 'react';

const useMobileAppBanner = () => {
    const [showMobileBanner, setShowMobileBanner] = useState(false);

    useEffect(() => {
        // Проверяем, был ли баннер уже закрыт
        const bannerClosed = sessionStorage.getItem('mobileBannerClosed');

        if (bannerClosed) {
            return;
        }

        // Определяем мобильное устройство
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        const isMobile = /iPad|iPhone|iPod|Android/i.test(userAgent);

        if (isMobile) {
            setShowMobileBanner(true);
        }
    }, []);

    const handleCloseBanner = useCallback(() => {
        setShowMobileBanner(false);
        sessionStorage.setItem('mobileBannerClosed', 'true');
    }, []);

    return {
        showMobileBanner,
        handleCloseBanner
    };
};

export default useMobileAppBanner;